import { createBrowserRouter, createRoutesFromElements, Route, Navigate, RouterProvider } from "react-router-dom";
import LanguageRouter from "./routers/LanguageRouter";
import RouterList from "./routers/Routers";

const router = createBrowserRouter(
    createRoutesFromElements(
        <>
            <Route
                path="/:lang/*"
                element={
                    <LanguageRouter>
                        <RouterList />
                    </LanguageRouter>
                }
            />
            <Route path="*" element={<Navigate to={`/id${window.location.pathname !== '/' ? window.location.pathname : ''}${window.location.search}`} replace />} />
        </>
    )
);

function App() {
    return <RouterProvider router={router} />;
}

export default App;
